import Image from "!url-loader!..\\..\\..\\..\\src\\images\\fotos\\DSC07021.jpg";
import MapGeorgetown from "..\\..\\..\\..\\src\\images\\minimaps\\reports\\minimap-guyana-georgetown.svg";
import * as React from 'react';
export default {
  Image,
  MapGeorgetown,
  React
};